import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useOrderTemplatesFilterViewModel = (requiresApproval) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [orderTemplates, setOrderTemplates] = useState([]);

  const getOrderTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.orderTemplates.getAll({
        sort: "name",
        filters: {
          ...(typeof requiresApproval === "boolean" && { requiresApproval }),
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const data = response.data.map((orderType) => ({
          ...orderType,
          label: orderType.name,
          value: orderType.id,
        }));
        setOrderTemplates(data);
      }
    });
  };

  return {
    isLoading,
    orderTemplates,
    getOrderTemplates,
  };
};
